class AppsSection extends HTMLElement {
  constructor() {
    super();
    // Instafeed
    document.addEventListener("instafeedAppLoaded", () => {
      const instaFeedId = "#insta-feed";
      const instaFeed = this.querySelector(instaFeedId);
      const heading = instaFeed.querySelector("h2");
      heading.classList.add("h3");

      const { instafeedSubheading } = this.dataset;

      if (!instafeedSubheading) return;

      const newParagraph = document.createElement("p");
      newParagraph.classList.add("my-custom-class");

      newParagraph.textContent = instafeedSubheading;
      heading.after(newParagraph);
    });
  }
}

if (!customElements.get("apps-section")) {
  customElements.define("apps-section", AppsSection);
}
